define('views/content/reseller_passive_home',['require','backbone','marionette','text!templates/content/reseller_passive_home.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');

    var temp = require("text!templates/content/reseller_passive_home.html");
    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-home-page',
        titleKey: 'home',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        }
    });
});
